export const NULL_RULE_KEY= "null-validation-strategy-key"
export const LIMIT_RULE_KEY = "limit-validation-strategy-key"
export const INVENTORY_RULE_KEY = "inventory-validation-strategy-key"


// WEBPACK FOOTER //
// ./src/state/price-list/ruleStrategyKeys.ts